<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.9 59.2">
  <path d="M94.3 0C83.2 0 73.6 6.1 68.5 15H10.9L0 29.6l10.9 14.6h.2l9.5-10.4L30 44.1l9.5-10.4L49 44.1h19.6c5.1 9 14.7 15 25.8 15 16.3 0 29.6-13.2 29.6-29.6C123.9 13.2 110.6 0 94.3 0zm8.1 38.7c-5 0-9.1-4.1-9.1-9.1s4.1-9.1 9.1-9.1 9.1 4.1 9.1 9.1-4 9.1-9.1 9.1z"/>
</svg>
</template>

<script>
export default {};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Unlocker.vue